import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/bind-f8092ad0.js';
import Selected from '../assets/Scelected.js';
import { noop } from '../../../utils/noop.js';
import { ColorCode } from '../../../constants/ui.js';
import { getTestId } from '../../../utils/testId.js';
import { onA11yKeyDown } from '../../../utils/a11y/onA11yKeyDown.js';
import { KeyboardKey } from '../../../constants/keyboard.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../../Icon/Icon.js';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';

var _excluded = ["title", "titleId"];
var RadioButton24 = function RadioButton24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("g", {
    clipPath: "url(#RadioButton24__a)"
  }, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5c5.79 0 10.5 4.71 10.5 10.5S17.79 22.5 12 22.5 1.5 17.79 1.5 12 6.21 1.5 12 1.5M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"
  })), /* @__PURE__ */React.createElement("defs", null, /* @__PURE__ */React.createElement("clipPath", {
    id: "RadioButton24__a"
  }, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};
RadioButton24.Size = 24;
RadioButton24.Title = "RadioButton";

var styles = {
  "unit-base": "4",
  "default": "web_ui__SelectionItem__default",
  "small": "web_ui__SelectionItem__small",
  "selection_item": "web_ui__SelectionItem__selection_item",
  "selected": "web_ui__SelectionItem__selected",
  "title": "web_ui__SelectionItem__title",
  "body": "web_ui__SelectionItem__body",
  "disabled": "web_ui__SelectionItem__disabled",
  "content": "web_ui__SelectionItem__content",
  "fit-content": "web_ui__SelectionItem__fit-content",
  "auto-fit": "web_ui__SelectionItem__auto-fit",
  "fixed-width": "web_ui__SelectionItem__fixed-width",
  "suffix-selected": "web_ui__SelectionItem__suffix-selected"
};

var Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Small"] = "small";
  return Size;
}({});
var Variant = /*#__PURE__*/function (Variant) {
  Variant["Parent"] = "auto";
  Variant["Content"] = "fit-content";
  Variant["Fixed"] = "fixed";
  return Variant;
}({});
var SELECTION_ITEM_CLASS = styles.selection_item;
var cssClasses = classNames.bind(styles);
var SelectionItem = function SelectionItem(_ref) {
  var id = _ref.id,
    prefix = _ref.prefix,
    title = _ref.title,
    body = _ref.body,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Default : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? Variant.Parent : _ref$variant,
    width = _ref.width,
    isSelected = _ref.isSelected,
    disabled = _ref.disabled,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    className = _ref.className,
    _ref$showSelectionInd = _ref.showSelectionIndicator,
    showSelectionIndicator = _ref$showSelectionInd === void 0 ? true : _ref$showSelectionInd,
    testId = _ref.testId,
    ariaLabel = _ref.ariaLabel,
    aria = _ref.aria,
    forwardedRef = _ref.forwardedRef;
  var selectionItemClass = cssClasses('selection_item', size, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.selected, isSelected), styles.disabled, disabled), styles['auto-fit'], variant === Variant.Parent), styles['fit-content'], variant === Variant.Content), styles['fixed-width'], variant === Variant.Fixed), className);
  var handleKeydown = function handleKeydown(event) {
    onA11yKeyDown(event, {
      keys: [KeyboardKey.Enter, KeyboardKey.Space]
    });
  };
  var renderPrefix = function renderPrefix() {
    if (!prefix) return null;
    return /*#__PURE__*/jsx("div", {
      children: prefix
    });
  };
  var renderTitle = function renderTitle() {
    if (!title) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.title,
      children: title
    });
  };
  var renderBody = function renderBody() {
    if (!body) return null;
    if (typeof body !== 'string') return /*#__PURE__*/jsx("div", {
      className: styles.body,
      children: body
    });
    return /*#__PURE__*/jsx("p", {
      className: styles.body,
      children: body
    });
  };
  var renderIcon = function renderIcon() {
    return isSelected ? /*#__PURE__*/jsx("span", {
      className: styles['suffix-selected'],
      children: /*#__PURE__*/jsx(Selected, {})
    }) : /*#__PURE__*/jsx(Icon, {
      name: RadioButton24,
      color: ColorCode.GreyscaleLevel3
    });
  };
  var renderSelectionIndicator = function renderSelectionIndicator() {
    return showSelectionIndicator ? renderIcon() : null;
  };
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    "data-id": id,
    className: selectionItemClass,
    role: "checkbox",
    "aria-checked": isSelected,
    "aria-disabled": disabled,
    "aria-label": ariaLabel,
    tabIndex: 0,
    onKeyDown: handleKeydown,
    onClick: disabled ? undefined : onClick,
    "data-testid": testId
  }, width ? {
    style: {
      width: width,
      minWidth: width
    }
  } : undefined), aria), {}, {
    ref: forwardedRef,
    children: [renderPrefix(), /*#__PURE__*/jsxs("div", {
      className: styles.content,
      "data-testid": getTestId(testId, 'content'),
      children: [renderTitle(), renderBody()]
    }), renderSelectionIndicator()]
  }));
};
var SelectionItemWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(SelectionItem, _objectSpread({
    forwardedRef: ref
  }, props));
});
SelectionItemWithForwardedRef.displayName = SelectionItem.name;
SelectionItemWithForwardedRef.Size = Size;
SelectionItemWithForwardedRef.Variant = Variant;

export { SELECTION_ITEM_CLASS, SelectionItemWithForwardedRef, Size, Variant, SelectionItemWithForwardedRef as default };
//# sourceMappingURL=SelectionItem.js.map
